export interface ErrorButtonModel {
  id?: string;
  text: string;
  action: ErrorAction;
  preventClosing?: boolean;
  handler?: () => void;
}

export type ErrorAction = 'retry' | 'stop';
